import React from 'react'

import { ConnectPortfolioWrapper } from './connect'
import { InvestPortfolioWrapper } from './invest'
import { PortfolioPage } from './portfolio'
import { getPortfolioStorage } from './storage/index'
import { Address, zeroAddress } from 'viem'

interface PortfolioWrapperProps {
  userAddress?: Address
}
export const PortfolioWrapper: React.FC<PortfolioWrapperProps> = ({ userAddress }) => {
  if (userAddress === zeroAddress) {
    return <ConnectPortfolioWrapper />
  }

  const storage = getPortfolioStorage()
  if (!storage.userHasBalanceHistory) {
    return <InvestPortfolioWrapper />
  }
  return <PortfolioPage portfolioStorage={storage} />
}

export default PortfolioWrapper
